/** Maximum allowed size for any uploaded file in bytes (10 MB). */
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

/** Maximum allowed size for any uploaded file in megabytes — used in user-facing copy. */
export const MAX_FILE_SIZE_MB = 10;

/**
 * Maximum allowed size for a deadline document (renewal, staging, AI preview) in bytes (25 MB):
 * municipal deeds and permits are often scanned PDFs well over 10 MB.
 */
export const MAX_DEADLINE_DOCUMENT_SIZE_BYTES = 25 * 1024 * 1024;

/** Maximum allowed size for a deadline document in megabytes — used in user-facing copy. */
export const MAX_DEADLINE_DOCUMENT_SIZE_MB = 25;

/** Maximum allowed size for a tenant label logo in bytes (3 MB). */
export const MAX_LABEL_LOGO_SIZE_BYTES = 3 * 1024 * 1024;

/** Maximum allowed size for a tenant label logo in megabytes — used in user-facing copy. */
export const MAX_LABEL_LOGO_SIZE_MB = 3;

/** MIME types accepted for a tenant label logo (the two most common image formats). */
export const LABEL_LOGO_ALLOWED_MIME_TYPES = ['image/png', 'image/jpeg'] as const;

/** File extensions accepted for a tenant label logo, for the upload control's `accept`. */
export const LABEL_LOGO_ALLOWED_EXTENSIONS = ['.png', '.jpg', '.jpeg'] as const;

/** Maximum allowed size for the tenant company profile logo in bytes (2 MB). */
export const MAX_TENANT_PROFILE_LOGO_SIZE_BYTES = 2 * 1024 * 1024;

/** Maximum allowed size for the tenant company profile logo in megabytes — used in user-facing copy. */
export const MAX_TENANT_PROFILE_LOGO_SIZE_MB = 2;

/** Maximum allowed size for a recipe (dish) photo in bytes (5 MB) — phone camera originals. */
export const MAX_RECIPE_PHOTO_SIZE_BYTES = 5 * 1024 * 1024;

/** Maximum allowed size for a recipe photo in megabytes — used in user-facing copy. */
export const MAX_RECIPE_PHOTO_SIZE_MB = 5;

/** MIME types accepted for a recipe photo. The storage layer re-encodes them to JPEG. */
export const RECIPE_PHOTO_ALLOWED_MIME_TYPES = ['image/png', 'image/jpeg', 'image/webp'] as const;

/** File extensions accepted for a recipe photo, for the upload control's `accept`. */
export const RECIPE_PHOTO_ALLOWED_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.webp'] as const;

/** Maximum allowed size for an ingredient photo in bytes (5 MB) — phone camera originals. */
export const MAX_INGREDIENT_PHOTO_SIZE_BYTES = 5 * 1024 * 1024;

/** Maximum allowed size for an ingredient photo in megabytes — used in user-facing copy. */
export const MAX_INGREDIENT_PHOTO_SIZE_MB = 5;

/** MIME types accepted for an ingredient photo. The storage layer re-encodes them to JPEG. */
export const INGREDIENT_PHOTO_ALLOWED_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'image/webp',
] as const;

/** File extensions accepted for an ingredient photo, for the upload control's `accept`. */
export const INGREDIENT_PHOTO_ALLOWED_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.webp'] as const;
